<div class="ag-grid-switch-container" (click)="$event.stopPropagation()">
  <label
    [ngClass]="['custom-switch', isDisabled ? 'disabled-switch' : '']"
  >
    <input
      type="checkbox"
      [checked]="value"
      [disabled]="isDisabled"
      (change)="onSwitchChange($event)"
    />
    <span class="slider"></span>
  </label>
  <span *ngIf="label" class="switch-label">{{ label | translate }}</span>
</div>
